import {START_TYPE} from '../actions/types';

const INITIAL_STATE = {
  showstartconfrim: true,
};

const User = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case START_TYPE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default User;
